import Siema from 'siema';
import { getSiblings } from '../helpers/bsselect';

function registerNavClick(element, homeAboutSlider) {
  element.addEventListener('click', function () {
    homeAboutSlider.goTo(element.getAttribute('data-siema-index'));
    handleNavChange(element);
  });
}

function handleNavChange(element) {
  element.classList.add('is-active');

  let siblings = getSiblings(element);
  for (let i = 0; i < siblings.length; i++) {
    let element = siblings[i];
    element.classList.remove('is-active');
  }

}

if (document.querySelector('.about-sider__slide-container')) {

  const nav = document.querySelectorAll('.about-slider__nav-link');

  const homeAboutSlider = new Siema({
    selector: '.about-sider__slide-container',
    duration: 200,
    easing: 'ease-out',
    perPage: 1,
    startIndex: 0,
    draggable: true,
    loop: false,
    onInit: () => { },
    onChange: () => {
      handleNavChange(nav[homeAboutSlider.currentSlide]);
    },
  });

  for (let i = 0; i < nav.length; i++) {
    registerNavClick(nav[i], homeAboutSlider);
  }

  window.addEventListener("load", () => {
    homeAboutSlider.resizeHandler();
  }, false);

}

if (document.querySelector('.gallery-slider__container')) {
  const galleryWrapper = document.querySelector('.gallery-slider__wrapper')
  const SiemaGallery = new Siema({
    selector: '.gallery-slider__container',
    perPage: 1,
    draggable: true,
    duration: 200,
    easing: 'ease-out',
    startIndex: 0,
    loop: false,
  });

  const next = galleryWrapper.querySelector('.gallery-slider__next');
  const prev = galleryWrapper.querySelector('.gallery-slider__prev');

  prev.addEventListener('click', () => SiemaGallery.prev());
  next.addEventListener('click', () => SiemaGallery.next());

  window.addEventListener("load", () => {
    SiemaGallery.resizeHandler();
  }, false);

}

if (document.querySelector('.quote-slider')) {
  const quoteSlider = new Siema({
    selector: '.quote-slider',
    perPage: 1,
    draggable: true,
    duration: 300,
    easing: 'ease-out',
    startIndex: 0,
    loop: true,
  });

  setInterval(function() {
    quoteSlider.next();
    console.log(quoteSlider);
    console.log('next');
  }, 5000);

  window.addEventListener("load", () => {
    quoteSlider.resizeHandler();
  }, false);

}




// WEBPACK FOOTER //
// ./assets/js/slider/siema.js